<script>
  import "./styles.scss";
  import Modal from "./UI/Modal.svelte";
  import Header from "./UI/Header.svelte";
  import Footer from "./UI/Footer.svelte";
  import Button from "./UI/Button.svelte";
  import Acknowledgement from "./UI/Acknowledgement.svelte";
  import Error from "./UI/Error.svelte";
  import AddRecord from "./Form/AddRecord.svelte";
  import { fade, fly } from "svelte/transition";
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();
  let createRecord;
  let isRecordCreated;
  let isError;

  function saved() {
    createRecord = null;
    isRecordCreated = "true";
  }

  function error() {
    createRecord = null;
    isRecordCreated = null;
    isError = "true";
    setTimeout(function() {
      isError = "false";
    }, 5000);
  }

  function cancelEdit() {
    createRecord = null;
    isRecordCreated = null;
  }
</script>

<Header />

<main>

  {#if createRecord === 'true'}
    <Modal>
      <AddRecord on:save={saved} on:cancel={cancelEdit} on:error={error} />
    </Modal>
  {:else}
    <body>
      <section class="section">
        <div class="container">

          <h2 class="has-text-centered title">Home Fire Campaign</h2>
          <br />
          <br />
          {#if isRecordCreated === 'false' || !isRecordCreated}
            <div>
              <p class="">
                This form is used by the American Red Cross and its partners to
                document Home Fire Campaign and National Sound the Alarm
                services. To learn more about the campaign please click
                <a
                  href="https://www.redcross.org/sound-the-alarm.html"
                  target="_blank">
                  here
                </a>
                <br />
                <br />
                <br />                
              </p>
            </div>
          {/if}
          <br />
          {#if isRecordCreated === 'true'}
            <p in:fly={{ y: 100, duration: 2500 }} out:fade>
              <Acknowledgement
                on:continue={() => (createRecord = 'true')}
                on:cancel={() => (isRecordCreated = 'false')} />
            </p>
          {:else}
            <section id="addrecord-controls">
              <div style="text-align: center;">
                <button
                  class="button is-danger"
                  on:click={() => (createRecord = 'true')}>
                  Create Record
                </button>
              </div>
            </section>
          {/if}
        </div>
        <br />
        {#if isError === 'true'}
          <p in:fly={{ y: 100, duration: 2500 }} out:fade>
            <Error />
          </p>
        {/if}
      </section>
    </body>
  {/if}
</main>
<Footer />
